
import {
  computed, defineComponent, PropType, toRefs,
} from 'vue-demi';
import AdmSymbol from '../AdmSymbol';
import {
  buttonSizeType, buttonVariantType, buttonThemeType, buttonDisplayType,
} from '../AdmButton/options';
import './icon-button.scss';

export default defineComponent({
  name: 'adm-icon-button',
  components: {
    AdmSymbol,
  },
  inheritAttrs: false,
  emits: ['click'],
  props: {
    id: {
      type: String,
      default: '',
      required: true,
    },
    href: {
      type: String,
      default: null,
    },
    to: {
      type: [String, Object],
      default: null,
    },
    icon: {
      type: String,
      default: '',
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String as PropType<buttonSizeType>,
      default: 'large',
    },
    variant: {
      type: String as PropType<buttonVariantType>,
      default: 'primary',
    },
    theme: {
      type: String as PropType<buttonThemeType>,
      default: 'default',
    },
    round: {
      type: Boolean,
      default: true,
    },
    display: {
      type: String as PropType<buttonDisplayType>,
      default: 'inline',
    },
  },
  setup(props) {
    const {
      href,
      to,
      disabled,
      size,
      variant,
      theme,
      round,
      display,

    } = toRefs(props);

    const tag = computed(() => {
      if (to.value) {
        return 'router-link';
      }
      return href.value ? 'a' : 'button';
    });

    const rootClass = 'adm-button';
    const iconModifierClass = 'adm-button--icon';
    const classes = computed(() => [
      rootClass,
      `${rootClass}--${size.value}`,
      `${rootClass}--${variant.value}`,
      `${rootClass}--${variant.value}-${theme.value}`,
      `${rootClass}--${display.value}`,
      {
        [`${rootClass}--disabled`]: disabled.value,
        [`${rootClass}--round`]: round.value,
      },
      iconModifierClass,
    ]);

    return {
      tag,
      classes,
    };
  },
});
